import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import  { GetContentCourseLevel }  from '../../controllers/GetContentCourseLevel';
import  { GetQuestionCourseLevel }  from '../../controllers/GetQuestionCourseLevel';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actions/auth';
import { useNavigate } from 'react-router-dom';

export const MainDataQuestion = ({fatherid, id, count_id, name, status_approved, url}) => {
    let user = useSelector( state => state.auth );
    const dispatch = useDispatch();
    const history = useNavigate();
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    
    const [urls, setUrls] = useState('');
    let ran = false;
    useEffect(() => {
        if (ran) return;

            if(url === "/information"){
                GetContentCourseLevel(id, user.languaje, token, user.id)
                .then((e)=>{
                    setUrls(`/information/${fatherid}/${id}/${e[0].id}`)
                })
                .catch((e)=>{
                    console.error(e);
                    dispatch(logout(token));
                });
            }
            else if(url === "/question"){
                GetQuestionCourseLevel(id, user.languaje, token, user.id)
                .then((e)=>{
                    setUrls(`/question/${fatherid}/${id}/${e[0].id}`)
                })
                .catch((e)=>{
                    console.error(e);
                    dispatch(logout(token));
                });
            }
            else if(url === "/child"){
                setUrls(`/child/${fatherid}/${id}`)
            }
        return () => (ran = true);
    }, [])
    
    return (
        // <div key={id} className={(id===count_id)?"btn-unit-main-on":(status_approved==="informativo")?"btn-unit-info":"btn-unit"}>
        <div key={id} className={(id===count_id)?"btn-unit":(status_approved==="pendiente")?"btn-unit-main-on":"btn-unit"}>
                <NavLink 
                to={`${urls}`} 
                    className="lkn-next wfp--link"
                >
                    <div className="btn-unit-text">
                    {name}
                    </div>
                    {/* <div className={(id===count_id)?"btn-unit-on":(status_approved==="pendiente")?"btn-unit-pending":(status_approved==="informativo")?"btn-unit-info-icon":"btn-unit-ok"}></div> */}
                    <div className={(id===count_id)?"btn-unit-pending":(status_approved==="pendiente")?"btn-unit-on":"btn-unit-ok"}></div>
                        

                </NavLink>
        </div>
    )
}
